import { isProxy, toRaw } from 'vue';

const state={
    isLogin : false,//目前是否已登入
    accessToken : '',//登入的TOKEN
}

const getters={
    getLoginAccount: state => {
        let returnData = toRaw(state.loginAccount);

        console.log('returnData',returnData);
      return returnData;
    },
    getAccessToken: state => {
        return state.accessToken;
    }
}

const mutations={
    //設定登入狀態
    "auth/setLogin" : function(state,value){
        state.isLogin = value;
    },
    //設定登入憑證
    "auth/setAccessToken" : function(state,token){
        state.accessToken = token;
    },
    //設定會員資訊
    "auth/setLoginAccount" : function(state,data){
        state.loginAccount = data;
    }
}

const actions={
    // 清除認證資料
    clearAuth({ commit }) {
        commit('auth/setLogin', false);
        commit('auth/setAccessToken', '');
        commit('auth/setLoginAccount', null);
        
        // 清除 localStorage 中的認證資料
        localStorage.removeItem('accessToken');
        localStorage.removeItem('loginAccount');
    }
}

export default{
    state,
    getters,
    mutations,
    actions,
}